var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "date-picker date-picker--standalone date-picker--full-width",
      class: {
        "date-picker--loading": _vm.loading
      }
    },
    [
      _c("Loader", {
        staticClass: "date-picker__loader",
        attrs: { show: _vm.loading }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "date-picker__header" }, [
        _c(
          "div",
          {
            staticClass:
              "date-picker__select-wrapper date-picker__select-wrapper--month-wrapper"
          },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentMonth,
                    expression: "currentMonth"
                  }
                ],
                staticClass: "date-picker__select",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.currentMonth = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.monthSelectChangeHandler
                  ]
                }
              },
              _vm._l(12, function(month) {
                return _c(
                  "option",
                  {
                    key: month,
                    attrs: {
                      disabled:
                        (_vm.currentYear === _vm.maxYear &&
                          month > _vm.maxMonth) ||
                        (_vm.currentYear === _vm.minYear &&
                          month < _vm.minMonth)
                    },
                    domProps: { value: month }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.getMonthDisplayName(month)) +
                        "\n          "
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("span", {
              staticClass: "date-picker__select-label",
              domProps: { innerHTML: _vm._s(_vm.currentMonthDisplay) }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "date-picker__select-wrapper date-picker__select-wrapper--year-wrapper"
          },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.currentYear,
                    expression: "currentYear"
                  }
                ],
                staticClass: "date-picker__select",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.currentYear = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.yearSelectChangeHandler
                  ]
                }
              },
              _vm._l(_vm.maxYear - _vm.minYear + 1, function(year, index) {
                return _c(
                  "option",
                  {
                    key: _vm.minYear + index,
                    domProps: { value: _vm.minYear + index }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.minYear + index) +
                        "\n          "
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("span", {
              staticClass: "date-picker__select-label",
              domProps: { innerHTML: _vm._s(_vm.currentYear) }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "date-picker__days-wrapper" },
        [
          _vm._l(_vm.dayNames, function(day) {
            return _c("span", {
              key: day,
              staticClass: "date-picker__day date-picker__day--name",
              domProps: { innerHTML: _vm._s(day) }
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.emptyDays, function(emptyDay) {
            return _c("span", {
              key: emptyDay,
              staticClass: "date-picker__day date-picker__day--empty"
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.daysOfMonth, function(day) {
            return _c(
              "label",
              {
                key:
                  _vm.uniqueId +
                  "-day-" +
                  _vm.currentYear +
                  "-" +
                  _vm.currentMonth +
                  "-" +
                  day,
                staticClass: "date-picker__day",
                attrs: {
                  for:
                    _vm.uniqueId +
                    "-day-" +
                    _vm.currentYear +
                    "-" +
                    _vm.currentMonth +
                    "-" +
                    day
                }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedDate,
                      expression: "selectedDate"
                    }
                  ],
                  staticClass: "date-picker__day-input",
                  attrs: {
                    type: "radio",
                    id:
                      _vm.uniqueId +
                      "-day-" +
                      _vm.currentYear +
                      "-" +
                      _vm.currentMonth +
                      "-" +
                      day,
                    disabled:
                      (_vm.currentYear === _vm.minYear &&
                        _vm.currentMonth === _vm.minMonth &&
                        day < _vm.minDay) ||
                      (_vm.currentYear === _vm.maxYear &&
                        _vm.currentMonth === _vm.maxMonth &&
                        day > _vm.maxDay) ||
                      _vm.isDateDisabled(
                        new Date(_vm.currentYear, _vm.currentMonth - 1, day)
                      ) ||
                      !_vm.isDateAvailable(_vm.formatDayDate(day))
                  },
                  domProps: {
                    value: _vm.formatDayDate(day),
                    checked: _vm._q(_vm.selectedDate, _vm.formatDayDate(day))
                  },
                  on: {
                    change: [
                      function($event) {
                        _vm.selectedDate = _vm.formatDayDate(day)
                      },
                      _vm.dayInputChangeHandler
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  _vm._g(
                    {
                      staticClass:
                        "date-picker__day-label date-picker__day-label--status",
                      class: [
                        _vm.availabilityClass(_vm.formatDayDate(day)),
                        {
                          "date-picker__day-label--today":
                            _vm.today === _vm.formatDayDate(day)
                        }
                      ]
                    },
                    _vm.selectedDate === _vm.formatDayDate(day)
                      ? { click: _vm.dayInputChangeHandler }
                      : {}
                  ),
                  [_vm._v("\n          " + _vm._s(day) + "\n        ")]
                )
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "date-picker__controls" },
        [
          _c("Button", {
            staticClass: "date-picker__controls-button",
            attrs: {
              level: "tertiary",
              type: "button",
              text: _vm.$t("forms.availabilities.prevMonth"),
              disabled:
                _vm.currentYear === _vm.minYear &&
                _vm.currentMonth === _vm.minMonth,
              arrow: "",
              reverse: ""
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.prevMonthBtnClickHandler.apply(null, arguments)
              }
            }
          }),
          _vm._v(" "),
          _c("Button", {
            staticClass: "date-picker__controls-button",
            attrs: {
              level: "tertiary",
              type: "button",
              text: _vm.$t("forms.availabilities.nextMonth"),
              disabled:
                _vm.currentYear === _vm.maxYear &&
                _vm.currentMonth === _vm.maxMonth,
              arrow: ""
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.nextMonthBtnClickHandler.apply(null, arguments)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.hideLegend && _vm.availabilities.length
        ? _c("div", { staticClass: "date-picker__legend" }, [
            _c(
              "ul",
              { staticClass: "date-picker__legend-status" },
              _vm._l(_vm.statuses, function(status) {
                return _c("li", {
                  key: status.key,
                  staticClass: "date-picker__legend-status-item",
                  class: ["date-picker__legend-status-item--" + status.name],
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("forms.availabilities.status." + status.key)
                    )
                  }
                })
              }),
              0
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }